import React from "react"
import NewsPost from "../components/newsPost"

function News(props){


  return(
    <div>
      <div className="container">
        <div className="row">
          <div className="col">
            <h1>News</h1>
          </div>
        </div>
        <div className="row justify-content-center align-items-center">

          <div className="col-md-6">
            <NewsPost />
          </div>
          <div className="col-md-6">
            <NewsPost />
          </div>
          <div className="col-md-6">
            <NewsPost />
          </div>
          <div className="col-md-6">
            <NewsPost />
          </div>
          <div className="col-md-6">
            <NewsPost />
          </div>

        </div>
      </div>
    </div>
  )
}



export default News